import { render, staticRenderFns } from "./Tool-Request.vue?vue&type=template&id=8648b9f2&scoped=true"
import script from "./Tool-Request.vue?vue&type=script&lang=js"
export * from "./Tool-Request.vue?vue&type=script&lang=js"
import style0 from "./Tool-Request.vue?vue&type=style&index=0&id=8648b9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8648b9f2",
  null
  
)

export default component.exports